import Script from 'next/script'
import React from 'react'

interface ToltScriptProps {
  apiKey: string
}

const ToltScript: React.FC<ToltScriptProps> = ({ apiKey }) => {
  return (
    <>
      <Script id="tolt-script" src="https://cdn.tolt.io/tolt.js" data-tolt={apiKey} strategy="lazyOnload" async />
    </>
  )
}

export default ToltScript
